import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {TaxEntityModel} from "../tax-entity.model";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {TaxData} from "../tax.data";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-tax-edit-page",
    templateUrl: "./tax-edit-page.component.html",
    providers: [(provideEntityModel(TaxEntityModel))]
})
export class TaxEditPageComponent extends AbstractEditPage {
    TaxData = TaxData;

    constructor(public model: TaxEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    methodSelect(): void {
        if (this.model.data.method === TaxData.SUBTRACTIVE_METHOD) {
            this.model.data.excludedFromBasePrice = false;
        }
    }
}
